<template>
  <div>
    <DxPopup
      :visible="popupVisible"
      :drag-enabled="false"
      :hide-on-outside-click="true"
      :show-title="true"
      :width="'75%'"
      :height="'75%'"
      :title="getTitle"
      @hidden="popupHidden"
      @shown="popupShown"
      :showCloseButton="false"
      :wrapperAttr="{ class: 'css-v2 gc-popup gc-popup-select-record' }"
    >
      <!-- <GcDataGrid
        :grouping="false"
        :export="false"
        :summary="false"
        :paging="false"
        :dataSourceConfig="{
          endpoint: 'StockEnquiryQuantity',
          filter: ['ItemCode', '=', `${itemData['ItemCode']}`],
          serverPaging: true,
          allowGrouping: false,
        }"
        :columns="columns"
        :gridToolbar="gridToolbar"
        :padColumn="false"
        :id="'grid-report-grid'"
        :auto-expand-all="false"
        :gridOptions="gridOptions"
        :gridHeightOverWrite="500"
        :toolbarHeader="{
          primary: itemData['Description'],
          secondary: itemData['ItemCode'],
        }"
      /> -->
      <div class="css-v2 transaction-list">
        <dx-data-grid
          :data-source="getDataSource"
          :columns="getColumns"
          :height="dataGridHeight"
          :column-chooser="{ enabled: false }"
          :show-column-headers="getShowColumnHeaders"
          :selection="{
            mode: getSelectionMode,
          }"
          @selection-changed="onSelectionChanged"
          @row-click="onRowClick"
          @toolbar-preparing="toolbarPreparing($event)"
          :ref="'gc-popup-select-record'"
          :selected-row-keys.sync="selectedRowKeys"
          :key-expr="getKeyExpr"
          :row-alternation-enabled="true"
          @content-ready="onContentReady"
        >
          <DxPaging :page-size="50" :enabled="false" />
          <DxPager
            :showInfo="true"
            :showPageSizeSelector="false"
            :infoText="'({2} items)'"
            :visible="false"
          />

          <DxScrolling
            :mode="'virtual'"
            :row-rendering-mode="'virtual'"
            :preload-enabled="true"
          />
        </dx-data-grid>
      </div>

      <div class="footer">
        <DxButton
          text="Add"
          type="default"
          styling-mode="contained"
          @click="onClickOnOk"
          class="add-btn"
          v-if="getAddBtnVisible"
          :disabled="getAddBtnDisable"
        />
        <DxButton
          text="Back"
          type="default"
          styling-mode="contained"
          @click="popupHidden"
        />
      </div>
    </DxPopup>
  </div>
</template>

<script>
import { SalesRepresentativeService } from "../../_services/api/sales/sales-rep.service";
export default {
  props: {
    popupVisible: {
      type: Boolean,
      default: false,
    },
    popupHiddenCallBack: {
      type: Function,
      default: () => {},
    },
    popupConfig: {
      type: Object,
      default: () => {},
    },
    dataModel: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [],
  data() {
    return {
      dataGridHeight: "auto",
      selectedRowKeys: [],
    };
  },
  async created() {
    if (
      this.popupConfig.dataGrid.options &&
      this.popupConfig.dataGrid.options.selectedValues
    ) {
      this.selectedRowKeys = this.popupConfig.dataGrid.options.selectedValues;
    }
  },
  computed: {
    getTitle() {
      return this.popupConfig.title;
    },
    getDataSource() {
      if (this.dataGridHeight != "auto")
        return this.popupConfig.dataGrid.dataSource;
      else return [];
    },
    getColumns() {
      return this.popupConfig.dataGrid.columns;
    },
    getShowColumnHeaders() {
      return false;
    },
    getSelectionMode() {
      if (this.popupConfig.dataGrid.options) {
        if (this.popupConfig.dataGrid.options.multipleSelect) return "multiple";
        else return "single";
      } else {
        return "single";
      }
    },
    getAddBtnVisible() {
      if (this.popupConfig.dataGrid.options) {
        if (this.popupConfig.dataGrid.options.multipleSelect) return true;
        else return false;
      } else {
        return false;
      }
    },
    getAddBtnDisable() {
      if (this.selectedRowKeys.length > 0) return false;
      else return true;
    },
    getKeyExpr() {
      if (this.popupConfig.dataGrid.options) {
        if (this.popupConfig.dataGrid.options.keyExpr)
          return this.popupConfig.dataGrid.options.keyExpr;
        else return undefined;
      } else {
        return undefined;
      }
    },
    getUserDefaultRep() {
      return this.popupConfig.dataGrid.toolbar &&
        this.popupConfig.dataGrid.toolbar.getUserDefaultRep
        ? this.popupConfig.dataGrid.toolbar.getUserDefaultRep
        : this.dataModel && this.dataModel.filterBySalesRep;
    },
  },
  watch: {},
  methods: {
    onContentReady(e) {
      if (e) {
        var data = {
          class: "no-data",
          title: "Uh-oh!",
          message:
            "We are struggling to find what you are looking for. Try altering your search criteria",
        };
        let noData = e.element.querySelector(
          ".dx-datagrid-nodata:not(.dx-hidden)"
        );

        if (noData) {
          // let img = `<img class="${data.class}" width="140" height="140" />`;
          // if (data.noImage) img = "";
          noData.innerHTML = `<div class="content-block home-content" ref="home-content">
                                <div>
                                  <span class='sm-oops'>${data.title}</span><br>
                                  <span> ${data.message}</span>
                                </div>
                              </div>`;
        }
      }
    },
    onSelectionChanged(e) {
      // eslint-disable-next-line no-console
      console.log("onSelectionChanged ", e);
    },
    onRowClick(e) {
      if (
        this.popupConfig.dataGrid.options &&
        this.popupConfig.dataGrid.options.onRowClick
      ) {
        this.popupConfig.dataGrid.options.onRowClick(e, this.getKeyExpr);
      }
    },
    popupHidden() {
      this.popupHiddenCallBack(false);
    },
    popupShown(e) {
      var content = e.component._$content;

      this.dataGridHeight =
        content[0].querySelectorAll(".dx-popup-content")[0].clientHeight - 60;

      // 60 = top padding + bottom padding + footer height
    },
    toolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });

      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return item.name !== "searchPanel";
      });

      searchPanel.location = "after";
      e.toolbarOptions.items.unshift(
        {
          location: "before",
          widget: "dxSelectBox",
          options: {
            width: 260,
            dataSource: SalesRepresentativeService.dataSourceConfig(
              "api/SalesRepresentative",
              {
                select: ["Code", "FirstName", "Surname"],
                filter: ["Inactive", "=", "N"],
                sort: [{ selector: "FirstName", asc: true }],
              }
            ),
            placeholder: "Sales Representative",
            valueExpr: "Code",
            value: this.getUserDefaultRep,
            showClearButton: true,
            searchEnabled: false,
            displayExpr: function (data) {
              if (data) return data.FirstName + " " + data.Surname;
            },
            onValueChanged: (e) => {
              let grid = this.$refs["gc-popup-select-record"].instance;
              if (e.value != null) {
                grid.filter([
                  ["SalesRepresentativeCode", "=", e.value],
                  "and",
                  ["Inactive", "=", "N"],
                ]);
              } else {
                grid.filter(["Inactive", "=", "N"]);
              }
            },
            showDataBeforeSearch: true,
            itemTemplate: (data) => {
              return ` <div class="custom-auto-complete">
                        <span class="auto-complete-primary">
                          ${data.FirstName}  ${data.Surname}
                        </span>
                        <span class="record-secondary gc-grid-code">
                          ${data.Code}
                        </span>
                      </div>`;
            },
          },
          visible:
            this.popupConfig.dataGrid.toolbar &&
            this.popupConfig.dataGrid.toolbar.salesrep,
        },
        searchPanel
      );
    },
    onClickOnOk() {
      if (
        this.popupConfig.dataGrid.options &&
        this.popupConfig.dataGrid.options.onOkClick
      ) {
        this.popupConfig.dataGrid.options.onOkClick(this.selectedRowKeys);
      }
    },
  },
};
</script>

<style lang="scss">
.gc-popup-select-record {
  .footer {
    .add-btn {
      margin-right: 10px;
    }
  }
  .dx-popup-content {
    .dx-scrollable-content {
      min-height: 100% !important;
      .dx-datagrid-table {
        thead {
          display: none;
        }
      }
    }
  }
}
</style>
